import { render, staticRenderFns } from "./RouteShopList.vue?vue&type=template&id=00a209a8&"
import script from "./RouteShopList.vue?vue&type=script&lang=js&"
export * from "./RouteShopList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports